export function sendDesktopNotification({ title = '', message = '' }) {
  return new Notification(title, {
    icon: 'https://dashboard-v2-images.s3.amazonaws.com/horizontal_nav_cb.svg',
    body: message,
    silent: false,
  });
}
